module.exports = __webpack_public_path__ + "static/img/Luke-Brooks.e740b7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Luke-Brooks.jpg
// module id = AQJH
// module chunks = 0